import { AbstractCommand } from 'src/models/command';

class CopyTheMailToTheDestinationAccountCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_CopyTheMailToTheDestinationAccountCommand';

	public constructor(aggregateId: string, destinationAccountIdConfiguration: number) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			destinationAccountIdConfiguration: destinationAccountIdConfiguration,
		};
	}
}

export { CopyTheMailToTheDestinationAccountCommand };
